import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { isWeb } from '../constants';
/**
 * On web, shows the QR code modal that opens the mobile app at `appLink` and
 * returns true, so the caller can stop. Opening accounts and moving money stay
 * mobile-only. Always returns false on native.
 */
export const showUnavailableOnWeb = (appLink, title) => {
    if (!isWeb) {
        return false;
    }
    UnavailableOnWebModal.show(appLink, title);
    return true;
};
